const getters = {
  HeaderText: state => state.SDKComponents.HeaderText,
  AndroidData: state => state.SDKComponents.AndroidData
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js